var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTaskShowCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 6.37891L13.043 5.75L12.4141 5.14844L8.47656 1.21094L7.875 0.582031L6.61719 1.8125L7.24609 2.44141L9.67969 4.875H1.75H0.875V6.625H1.75H9.67969L7.24609 9.08594L6.61719 9.6875L7.875 10.9453L8.47656 10.3164L12.4141 6.37891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTaskShowCategory);
export default __webpack_public_path__ + "static/media/arrow_task_show_category.3fe5a90c778d439341a46f7043683d66.svg";
export { ForwardRef as ReactComponent };